'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002413 from "./presto.-Dashboard-View$$anon$13.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002415 from "./presto.-Dashboard-View$$anon$15.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002419 from "./presto.-Dashboard-View$$anon$19.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002421 from "./presto.-Dashboard-View$$anon$21.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002423 from "./presto.-Dashboard-View$$anon$23.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002425 from "./presto.-Dashboard-View$$anon$25.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dLogins$002dResponse$0024 from "./presto.types$-Dashboard-Logins-Response$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$12(outer) {
  this.aJ8 = null;
  this.aJ0 = null;
  this.aJ1 = false;
  this.aJ9 = null;
  this.aJa = false;
  this.aJd = null;
  this.aJ6 = null;
  this.aJ7 = false;
  this.aJ2 = null;
  this.aJ3 = false;
  this.aJ4 = null;
  this.aJ5 = false;
  this.aJb = false;
  this.aJc = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aJ8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJd = "DashboardLoginsResponse";
}
export { $c_Lpresto_DashboardView$$anon$12 as $c_Lpresto_DashboardView$$anon$12 };
$p = $c_Lpresto_DashboardView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$12;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$12() {
}
export { $h_Lpresto_DashboardView$$anon$12 as $h_Lpresto_DashboardView$$anon$12 };
$h_Lpresto_DashboardView$$anon$12.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aJ8;
});
$p.L = (function() {
  if ((!this.aJ1)) {
    this.aJ0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJ1 = true;
  }
  return this.aJ0;
});
$p.O = (function() {
  if ((!this.aJa)) {
    this.aJ9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJa = true;
  }
  return this.aJ9;
});
$p.E = (function() {
  return this.aJd;
});
$p.t = (function() {
  if ((!this.aJ7)) {
    this.aJ6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("errors", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hosts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hostStats", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("systemStats", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("topUsers", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("topAccounts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sign", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))))));
    this.aJ7 = true;
  }
  return this.aJ6;
});
$p.M = (function() {
  if ((!this.aJ3)) {
    this.aJ2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().o6, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().v9())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002413.$c_Lpresto_DashboardView$$anon$13())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002415.$c_Lpresto_DashboardView$$anon$15())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002419.$c_Lpresto_DashboardView$$anon$19())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002421.$c_Lpresto_DashboardView$$anon$21())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002423.$c_Lpresto_DashboardView$$anon$23())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))))));
    this.aJ3 = true;
  }
  return this.aJ2;
});
$p.Q = (function() {
  if ((!this.aJ5)) {
    this.aJ4 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002425.$c_Lpresto_DashboardView$$anon$25();
    this.aJ5 = true;
  }
  return this.aJ4;
});
$p.w = (function() {
  if ((!this.aJc)) {
    this.aJb = false;
    this.aJc = true;
  }
  return this.aJb;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee128) => ((p) => \u03b4scrutinee128.cGn(p)))($j_presto$002etypes$0024$002dDashboard$002dLogins$002dResponse$0024.$m_Lpresto_types$DashboardLoginsResponse$())));
});
var $d_Lpresto_DashboardView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$12, "presto.DashboardView$$anon$12", ({
  GD: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$12 as $d_Lpresto_DashboardView$$anon$12 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$12.js.map
